module.exports = __webpack_public_path__ + "static/img/logo_bg.b27d178.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_bg.png
// module id = p1s7
// module chunks = 12